import React from 'react';
// Per primo: definisce colori e caratteri usati da tutti gli altri fogli.
import './styles/tema.css';
import ReactDOM from 'react-dom/client';
import App from './App';
/* I colori della struttura, scritti sulle variabili di tema.css. Prima
   del primo disegno: il foglio di stile porta una palette neutra, e
   questa la sostituisce con quella del cliente. Se il server non
   risponde resta la neutra, che e' leggibile. */
import { caricaPalette } from './utils/palette';

caricaPalette();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
